import React from "react";
import MedicationCardTitle from "./medication-card-title";
import MedicationCardAttributes from "./medication-card-attributes";
import MedicationPriceCard from "./medication-price-card";
import { Medication } from "../../types";

export interface MedicationCardProps {
    medicationId: string;
    medication: Medication;
}

const MedicationCard = ({medicationId, medication}: MedicationCardProps) => {
    return (
        <pui-card id={medicationId} class="medication-card" spacingleft="med-small" spacingright="med-small" fullWidth>
            <MedicationCardTitle {...medication.medicationInfo} />
            <MedicationCardAttributes medicationIntake={medication.medicationIntake}
                                      attributes={medication.medicationOptions}/>
            <pui-section padding="small">
                <pui-divider></pui-divider>
            </pui-section>
            <MedicationPriceCard medicationPricing={medication.medicationPricing}
                                 medicationRetailPricing={medication.medicationRetailPricing}/>
        </pui-card>
    );
}

export default MedicationCard;
